






import { Component, Vue } from 'vue-property-decorator';
import { Select } from '@/pages/profile/blocks';

@Component({
  components: {
    Select,
  },
})
export default class MentoringMeetingResult extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/modal/components/meeting/components/results/MentoringMeetingResult.vue